import React from 'react';
import InfoBox from './InfoBox';
import { formataMoeda } from '../../Helpers/money';


function InfoBoxSalario (props) {
  let { f } = props;
  return (
    <InfoBox
      iconName="hand-holding-usd"
      label={(f.Categoria != 5) ? "Salário" : "Salário-hora"}
      value={formataMoeda(f.Salario, {removeCents: (f.Categoria != 5)})}
      details={(f.Categoria == 5) && formataMoeda(parseFloat(f.HorasMes) * parseFloat(f.Salario)) + " /mês"}
    />
  )
}

export default InfoBoxSalario;
